import React from 'react';
import EsDeskMonitor from './EsDeskMonitor';
// SIRIUS — RTH ES momentum SHORT (Grade A). Wave 1.
export default function SiriusMonitor() { return <EsDeskMonitor system="sirius" accent="#a855f7" />; }
